<template>
  <a
    class="materiality-card"
    :class="{ visible: isVisible }"
    @click.stop="navigateToLink"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <div class="content">
      <div class="title-container">
        <h3 class="impact-title">Financial Materiality</h3>
        <img
          v-if="isHovered"
          src="/static_img/skinc/appendix/arrow_focus.svg"
          class="arrow-icon"
          alt="arrow"
        />
        <img
          v-else
          src="/static_img/skinc/appendix/arrow_normal.svg"
          class="arrow-icon"
          alt="arrow"
        />
      </div>

      <p v-if="lang !== 'ENG'" class="description">
        재무 성과에 중대한 영향을 미치는 위험 및 기회 요인을 분석하고<br />
        중요 주제를 선별하였습니다.
      </p>
      <p v-else class="description en-font">
        Risks and opportunities with significant impact on financial performance were analyzed to
        identify material topics.
      </p>

      <div class="topic-list" :class="{ 'en-font': lang === 'ENG' }">
        <a
          v-for="(topic, index) in cardInfo.topics"
          :key="index"
          :href="topic.link"
          class="topic-item"
        >
          #{{ topic.name }}
        </a>
      </div>
    </div>
  </a>
</template>

<script>
import { mapState } from 'vuex';
import { financialCardInfo } from '@/components/main_pages/skinc/skincData.js';

export default {
  name: 'Result2',
  props: {
    link: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isHovered: false,
      isVisible: false,
      observer: null
    };
  },
  computed: {
    ...mapState('report_list', ['lang']),
    cardInfo() {
      return financialCardInfo[this.lang] || financialCardInfo.KOR;
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.isVisible = entry.isIntersecting;
      },
      {
        threshold: 0.2
      }
    );

    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    navigateToLink() {
      if (!this.link) {
        return;
      }
      const finalLink = new URL(this.link, window.location.origin);
      if (this.lang === 'ENG') {
        finalLink.searchParams.set('l', 'ENG');
      } else {
        finalLink.searchParams.delete('l');
      }
      window.location.href = finalLink.href;
    }
  }
};
</script>

<style scoped>
.materiality-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  background-color: white;
  height: auto;
  min-height: 400px;
  padding: clamp(1.5rem, 3vw, 2.5rem);
  box-sizing: border-box;
  border: 1px solid #d1d5db;
  border-radius: 16px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  overflow: hidden;
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease 0.8s, transform 0.8s ease 0.8s, box-shadow 0.3s ease 0.8s;
}

.materiality-card.visible {
  opacity: 1;
  transform: translateY(0);
}

.materiality-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
}

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  width: 100%;
}

.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
}

.impact-title {
  font-weight: bold;
  color: #000;
  font-size: clamp(24px, 3vw, 40px);
}

.arrow-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.description {
  color: #4b4b4b;
  line-height: 1.6;
  margin-bottom: 24px;
  font-size: clamp(18px, 2.5vw, 24px);
  margin-bottom: 2rem;
}

.topic-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
}

.topic-item {
  background-color: #e9e9e9;
  color: #555;
  padding: 6px 12px;
  border-radius: 100px;
  font-weight: 500;
  font-size: clamp(12px, 1.5vw, 16px);
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.topic-item:hover {
  background-color: #ee7501;
  color: white;
}

.description.en-font {
  font-size: clamp(14.4px, 2vw, 19.2px);
}

.topic-list.en-font .topic-item {
  font-size: clamp(9.6px, 1.2vw, 12.8px);
}
</style>
